import './LoadingState.css';
export var dataTableHeaderHeight = 'var(--_14flfjk0-3-15-1)';
export var dataTableScrollOffset = 'var(--_14flfjk1-3-15-1)';
export var loadingState = '_14flfjk2-3-15-1';